<!-- The notification pre-prompt. Asked once, the first time a page leaves the
     pager — never on launch (IDEATION → First run → Permissions). -->
<template>
  <IonModal
    :is-open="isOpen"
    :initial-breakpoint="1"
    :breakpoints="[0, 1]"
    class="pm-scr-sheet pm-scr-sheet--auto"
    @will-present="onPresent"
    @did-dismiss="onDismiss"
  >
    <div class="pm-scr-sheet-body">
      <p class="pm-scr-lcd-line" aria-hidden="true">BEEPS</p>
      <h2 class="section-title">Get beeped when a friend pages</h2>

      <template v-if="!outcome">
        <p>Page Me can beep you when a friend pages, even when the app is closed. That needs notifications.</p>
        <div class="pm-scr-stack">
          <IonButton expand="block" :disabled="turnOn.busy.value" @click="turnOn.run()">
            {{ turnOn.busy.value ? 'Asking…' : 'Turn on beeps' }}
          </IonButton>
          <IonButton expand="block" fill="outline" :disabled="turnOn.busy.value" @click="notNow">Not now</IonButton>
        </div>
        <p v-if="turnOn.error.value" class="field-error" role="alert">{{ turnOn.error.value }}</p>
      </template>

      <template v-else-if="outcome === 'denied'">
        <p>Notifications are off for Page Me, so it can only beep while it's open.</p>
        <p class="pm-scr-muted">To turn them on, open your phone's Settings, find Page Me, and allow notifications.</p>
        <IonButton expand="block" @click="close">OK</IonButton>
      </template>

      <template v-else-if="outcome === 'unavailable'">
        <p>Beeps only while Page Me is open.</p>
        <p class="pm-scr-muted">Pages still arrive whenever you open it. Install the app to get beeped when it's closed.</p>
        <IonButton expand="block" @click="close">OK</IonButton>
      </template>
    </div>
  </IonModal>
</template>

<script setup>
import { ref } from 'vue';
import { IonModal, IonButton } from '@ionic/vue';
import { useAction } from '../core/ui/index.js';
import { enableBeeps, dismissBeepsOffer } from '../store.js';

defineProps({ isOpen: { type: Boolean, default: false } });
const emit = defineEmits(['close']);

const outcome = ref('');
let answered = false;

const turnOn = useAction(async () => {
  const result = await enableBeeps();
  answered = true;
  if (result === 'granted') {
    close();
    return;
  }
  outcome.value = result === 'denied' ? 'denied' : 'unavailable';
}, { weight: 'pop' });

function notNow() {
  answered = true;
  dismissBeepsOffer();
  close();
}

function close() { emit('close'); }

let opener = null;
function onPresent() {
  opener = document.activeElement;
  outcome.value = '';
  answered = false;
}
function onDismiss() {
  // Swiping the sheet away is a "Not now", not a silent skip.
  if (!answered) dismissBeepsOffer();
  emit('close');
  const el = opener;
  opener = null;
  try { el?.focus?.(); } catch { /* gone */ }
}
</script>
